import { TriangleAlert } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface RouteErrorProps {
  error?: unknown
  reset?: () => void
}

function RouteError({ error, reset }: RouteErrorProps) {
  const message = error instanceof Error ? error.message : 'An unexpected error occurred.'

  return (
    <div className="flex min-h-[60svh] flex-col items-center justify-center gap-4 px-4 text-center">
      <div className="bg-destructive/10 text-destructive flex size-12 items-center justify-center rounded-full">
        <TriangleAlert className="size-6" />
      </div>
      <div className="space-y-1">
        <h1 className="text-foreground text-lg font-semibold">Something went wrong</h1>
        <p className="text-muted-foreground max-w-sm text-sm">{message}</p>
      </div>
      {reset && (
        <Button onClick={reset} variant="outline">
          Try again
        </Button>
      )}
    </div>
  )
}

export { RouteError }
